// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ep9dT","content":"styles_content__YdNUb","tableWrap":"styles_tableWrap__2JD2T"};